import { DashboardSpeed01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Gauge = /* @__PURE__ */ createIcon(DashboardSpeed01Icon, 'Gauge');
